import { MENU_SECTION_IDS, TOOL_ITEM_IDS } from '@/constants/services'

export default {
  menu: [
    {
      text: '',
      key: '',
      sectionId: MENU_SECTION_IDS.DASHBOARD,
      items: [
        {
          icon: 'mdi-view-dashboard-outline',
          text: 'Dashboard',
          link: '/dashboard/analytics'
        }
      ]
    },
    {
      text: 'Campañas',
      key: '',
      sectionId: MENU_SECTION_IDS.CAMPAIGNS,
      items: [
        { icon: 'mdi-bullhorn', text: 'Campañas', link: '/services' },
        {
          icon: 'mdi-chart-line',
          text: 'Reportería',
          items: [
            { text: 'Campañas', link: '/reports/campaigns' },
            { text: 'Consumos', link: '/reports/registers' }
          ]
        }
      ]
    },
    {
      text: 'Atención al cliente',
      key: '',
      sectionId: MENU_SECTION_IDS.CUSTOMER_CARE,
      items: [
        {
          icon: 'mdi-headset',
          text: 'Atención al cliente',
          items: [
            { text: 'Configuración', link: '/management/workgroups' },
            { text: 'Supervisar', link: '/management/supervisor' }
          ]
        }
      ]
    },
    {
      text: 'Herramientas',
      key: '',
      sectionId: MENU_SECTION_IDS.TOOLS,
      items: [
        { icon: 'mdi-file-image', text: 'Archivos', link: '/tools/filescloud', itemId: TOOL_ITEM_IDS.FILES },
        { icon: 'mdi-link-plus', text: 'URL', link: '/tools/shorturl', itemId: TOOL_ITEM_IDS.SHORT_URL },
        { icon: 'mdi-contacts', text: 'Agendas', link: '/tools/agendas', itemId: TOOL_ITEM_IDS.AGENDAS },
        { icon: 'mdi-block-helper', text: 'Lista negra', link: '/tools/blacklist', itemId: TOOL_ITEM_IDS.BLACKLIST }
      ]
    },
    {
      text: 'Chat',
      key: '',
      sectionId: MENU_SECTION_IDS.CHAT,
      items: [
        { icon: 'mdi-message', text: 'Chat', link: '/agent/tools/chat' }
      ]
    },
    {
      text: 'Configuración',
      key: '',
      sectionId: MENU_SECTION_IDS.SETTINGS,
      items: [
        {
          icon: 'mdi-account-group',
          text: 'Usuarios',
          link: '/config/users'
        }
      ]
    },
    {
      text: 'Canales',
      key: '',
      sectionId: MENU_SECTION_IDS.CHANNELS,
      items: [
        {
          icon: 'mdi-send',
          text: 'Senders',
          link: '/channels/senders'
        },
        {
          icon: 'mdi-call-split',
          text: 'Proveedores',
          link: '/channels/vendors'
        }
      ]
    },
    {
      text: 'Soporte',
      key: '',
      sectionId: MENU_SECTION_IDS.SUPPORT,
      items: [
        {
          icon: 'mdi-call-split',
          text: 'Flows',
          link: '/support/flows'
        }
      ]
    },
    {
      text: 'Documentación',
      key: '',
      sectionId: MENU_SECTION_IDS.DOCUMENTATION,
      items: [
        {
          icon: 'mdi-file-document',
          text: 'Documentación Api',
          link: '/enviamas-documentation'
        }
      ]
    },
    {
      text: 'Otros',
      key: '',
      sectionId: MENU_SECTION_IDS.OTHERS,
      items: [
        {
          icon: 'mdi-call-split',
          text: 'Bots',
          link: '/bots'
        },
        {
          icon: 'mdi-call-split',
          text: 'Compañias',
          link: '/companies'
        }
      ]
    }
  ]
}
